import { ParameterType } from '@/study-search/enums';

import { ParsedFilter } from '../generalizations/ParsedFilter';

class SearchCriteriaParser {
	public parse(searchCriteria: string | undefined | string[]): ParsedFilter[] {
		const filters: ParsedFilter[] = [];
		if (searchCriteria === undefined) return filters;

		if (Array.isArray(searchCriteria)) {
			searchCriteria = searchCriteria.join(',');
		}

		const searchCriteriaParts: string[] = searchCriteria.split('|');
		const validSearchCriteriaParts: string[] = searchCriteriaParts.filter((_) => _.match('.+-.+'));

		this.addDurationFilter(
			filters,
			validSearchCriteriaParts.find((_) => _.includes(`${ParameterType.DURATION}`))
		);
		this.addTuitionFeeFilter(
			filters,
			validSearchCriteriaParts.find((_) => _.includes(`${ParameterType.TUITION_FEE}`))
		);
		this.addRemainingFilters(
			filters,
			validSearchCriteriaParts.filter(
				(_) => !_.includes(`${ParameterType.DURATION}`) && !_.includes(`${ParameterType.TUITION_FEE}`)
			)
		);

		return filters;
	}

	private addDurationFilter(filters: ParsedFilter[], searchCriteriaPart: string | undefined): void {
		if (searchCriteriaPart === undefined) return;

		const durationFilter = new ParsedFilter(ParameterType.DURATION);

		const optionValues = searchCriteriaPart.match(/\[.*?\]/g);
		if (optionValues !== null) {
			durationFilter.values = durationFilter.values.concat(optionValues);
		}

		filters.push(durationFilter);
	}

	private addTuitionFeeFilter(filters: ParsedFilter[], searchCriteriaPart: string | undefined): void {
		if (searchCriteriaPart === undefined) return;

		const tuitionFeeFilter = new ParsedFilter(ParameterType.TUITION_FEE);

		const optionValues = searchCriteriaPart.match(/\[.*?\]/g);
		if (optionValues !== null) {
			tuitionFeeFilter.values = tuitionFeeFilter.values.concat(optionValues);
		}

		filters.push(tuitionFeeFilter);
	}

	private addRemainingFilters(filters: ParsedFilter[], searchCriteriaParts: string[]): void {
		if (searchCriteriaParts.length !== 0) {
			searchCriteriaParts.forEach((_) => filters.push(this.reconstituteFilter(_)));
		}
	}

	private reconstituteFilter(searchCriteriaPart: string): ParsedFilter {
		const type = searchCriteriaPart.split('-')[0];
		const values = searchCriteriaPart.split('-')[1].split(',');

		return new ParsedFilter(type, values);
	}
}

export default new SearchCriteriaParser();
